export default __webpack_public_path__ + "static/project-slide-1-4032-2268-dbebe74d7d1c6359d9838083703c1ea8.webp";